"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMaxOrUndefined = exports.isNumber = exports.findAverageOrUndefined = void 0;
const findAverageOrUndefined = (a, b) => {
    const aIsNumber = (0, exports.isNumber)(a);
    const bIsNumber = (0, exports.isNumber)(b);
    if (!aIsNumber && !bIsNumber) {
        return undefined;
    }
    if (!aIsNumber) {
        return b;
    }
    if (!bIsNumber) {
        return a;
    }
    return (a + b) / 2;
};
exports.findAverageOrUndefined = findAverageOrUndefined;
const isNumber = (a) => {
    return a != null && !isNaN(a);
};
exports.isNumber = isNumber;
const findMaxOrUndefined = (a, b) => {
    const aIsNumber = (0, exports.isNumber)(a);
    const bIsNumber = (0, exports.isNumber)(b);
    if (!aIsNumber && !bIsNumber) {
        return undefined;
    }
    if (!aIsNumber) {
        // @ts-expect-error ts2322: b is a number based on check above
        return b;
    }
    if (!bIsNumber) {
        return a;
    }
    return Math.max(a, b);
};
exports.findMaxOrUndefined = findMaxOrUndefined;
//# sourceMappingURL=mos_quality_score_utils.js.map